/**
 * @desc getRoleUserRelationByRoleCodes
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.RoleUserRelationResponseDto>
>;
export function request(
  params: API.appCenter.appFacadeImpl.getRoleUserRelationByRoleCodes.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/roleUserRelation/list/roleCodes`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
